export default __webpack_public_path__ + "static/media/Mandalorian.80ebf3a7.png";